import { useState } from "react"
import "./heroMenu.css"

export function HeroMenu() {
    const [subMenuShown1, setSubMenuShown1] = useState(false)
    const [subMenuShown2, setSubMenuShown2] = useState(false)
    const [subMenuSmShown1, setSubMenuSmShown1] = useState(false)
    const [subMenuSmShown2, setSubMenuSmShown2] = useState(false)

    const [cltWidth, setCltWidth] = useState(null)
    const [scrlWidth, setScrlWidth] = useState(null)
    const [scrlLeft, setScrlLeft] = useState(0)

    function toggleSubMenu1() {
        setSubMenuSmShown1(true)
        setSubMenuShown1(!subMenuShown1)
    }

    function toggleSubMenu2() {
        setSubMenuSmShown2(true)
        setSubMenuShown2(!subMenuShown2)
    }

    return (
        <div
            className={
                `menu d-flex ${!subMenuSmShown1 && !subMenuSmShown2 ? 
                (scrlLeft === 0 ? "right-fade " 
                : parseInt(scrlLeft) === scrlWidth - cltWidth ? " left-fade" 
                : " x-fade") : ""}`
            }
            onScroll={(e) => {
                setCltWidth(e.target.clientWidth)
                setScrlWidth(e.target.scrollWidth)
                setScrlLeft(e.target.scrollLeft)
            }}>
            <div className={`w-100 flex-column align-items-center gap-5 sub-menu-sm bg-white py-2 px-3 overflow-scroll ${subMenuSmShown1 ? "on" : ""}`}>
                <i
                    className="fa-solid fa-x fs-1 align-self-start mt-2"
                    onClick={() => setSubMenuSmShown1(false)}>
                </i>
                <h1>Item 1</h1>
                <h1>Item 2</h1>
                <h1>Item 3</h1>
                <h1>Item 4</h1>
                <h1>Item 5</h1>
                <h1>Item 6</h1>
            </div>
            <div className={`w-100 flex-column align-items-center gap-5 sub-menu-sm bg-white py-2 px-3 overflow-scroll ${subMenuSmShown2 ? "on" : ""}`}>
                <i
                    className="fa-solid fa-x fs-1 align-self-start mt-2"
                    onClick={() => setSubMenuSmShown2(false)}>
                </i>
                <h1>Item 1</h1>
                <h1>Item 2</h1>
                <h1>Item 3</h1>
                <h1>Item 4</h1>
                <h1>Item 5</h1>
                <h1>Item 6</h1>
            </div>
            <div className="d-flex align-items-center position-relative parent-menu categories-list"
                onClick={toggleSubMenu1}
                onMouseLeave={() => setSubMenuShown1(false)}>
                <div className="my-auto">Women's Fashion</div>
                <div className="left-arrow"></div>
                <div className={`d-flex flex-column gap-2 position-absolute sub-menu ${subMenuShown1 ? "on" : ""}`}>
                    <h6>Item 1</h6>
                    <h6>Item 2</h6>
                    <h6>Item 3</h6>
                    <h6>Item 4</h6>
                    <h6>Item 5</h6>
                    <h6>Item 6</h6>
                </div>
            </div>
            <div className="d-flex align-items-center position-relative parent-menu categories-list"
                onClick={toggleSubMenu2}
                onMouseLeave={() => setSubMenuShown2(false)}>
                <div className="my-auto">Men's Fashion</div>
                <div className="left-arrow"></div>
                <div className={`d-flex flex-column gap-2 position-absolute sub-menu ${subMenuShown2 ? "on" : ""}`}>
                    <h6>Item 1</h6>
                    <h6>Item 2</h6>
                    <h6>Item 3</h6>
                    <h6>Item 4</h6>
                    <h6>Item 5</h6>
                    <h6>Item 6</h6>
                </div>
            </div>
            <div className="categories-list"><div className="my-auto">Electronics</div></div>
            <div className="categories-list"><div className="my-auto">Home & Lifestyle</div></div>
            <div className="categories-list"><div className="my-auto">Medicine</div></div>
            <div className="categories-list"><div className="my-auto">Sports & Outdoor</div></div>
            <div className="categories-list"><div className="my-auto">Baby's & Toys</div></div>
            <div className="categories-list"><div className="my-auto">Groceries & Pets</div></div>
            <div className="categories-list"><div className="my-auto">Health & Beauty</div></div>
        </div>
    )
}
